import LoadChunk from 'src/app/services/LoadChunk/LoadChunk';

const SessionsReportRoute = LoadChunk(() => import('./SessionReport/SessionsReportRoute'));
const MonitoringRoute = LoadChunk(() => import('src/layouts/analytics/SessionMonitoringContainer'));

export default {
  SessionsReportRoute,
  MonitoringRoute
};
